import { type BaseQueryFn, createApi } from '@reduxjs/toolkit/query/react'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { createAxiosInstance } from '../../api'
import { DashboardData } from '../../types'

export const apiStatsBaseQuery =
  (): BaseQueryFn<
    {
      url: string
      method: AxiosRequestConfig['method']
      data?: AxiosRequestConfig['data']
      params?: AxiosRequestConfig['params']
      headers?: AxiosRequestConfig['headers']
    },
    unknown,
    unknown
  > =>
  async ({ url, method, data, params, headers }) => {
    const api = createAxiosInstance(`${String(process.env.REACT_APP_ENGINE_API_URL)}/reporting/stats`)

    try {
      const result = await api(url, {
        method,
        data,
        params,
      })
      return { data: result.data }
    } catch (axiosError) {
      const err = axiosError as AxiosError
      console.error(err)

      throw axiosError
    }
  }

export const statsApi = createApi({
  reducerPath: 'statsApi',
  baseQuery: apiStatsBaseQuery(),
  endpoints: (builder) => ({
    getStats: builder.query<DashboardData, void>({
      query() {
        return {
          url: '',
          method: 'get',
        }
      },
    }),
  }),
})

export const { useLazyGetStatsQuery } = statsApi
